import { _ as c } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.symbol.description-6025a604.js";
import "./es.object.assign-7e79fd7b.js";
import { QUERIES as p } from "@ucl/shared-component-foundations";
import o, { css as P } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as w } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as B } from "./useWindowSize.js";
import { Divider as k } from "./divider.js";
import { hTag as b } from "./hTag.js";
import { jsxs as a, jsx as n } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./index-8b07dec9.js";
var x = ["$titleSize"], A = ["$hideBackground"], D = ["children", "actionButtons", "titleProp", "subTitleProp", "description", "hideBackground", "bottomStroke", "breadCrumbContent", "tabContent"], z = /* @__PURE__ */ o.div.withConfig({
  displayName: "pageHeader__PageHeaderWrapper",
  componentId: "bfy3bu-0"
})(["", ";display:", ";flex-direction:", ";gap:", ";"], function(e) {
  var r = e.theme.componentStyles;
  return P(r);
}, function(e) {
  return e.theme.components.pageHeader.PageHeaderWrapper.display;
}, function(e) {
  return e.theme.components.pageHeader.PageHeaderWrapper.flexDirection;
}, function(e) {
  return e.theme.components.pageHeader.PageHeaderWrapper.gap;
}), _ = function() {
  return `
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`;
}, $ = /* @__PURE__ */ o(b).withConfig({
  displayName: "pageHeader__TitleWrapper",
  componentId: "bfy3bu-1"
})(["color:", ";", ""], function(e) {
  return e.theme.components.pageHeader.TitleWrapper.color;
}, function(e) {
  var r = e.$titleSize, t = c(e, x);
  switch (r) {
    case "large":
      return t.theme.components.pageHeader.TitleWrapper.titleSize.large;
    case "extraLarge":
      return t.theme.components.pageHeader.TitleWrapper.titleSize.extraLarge;
    case "medium":
    default:
      return t.theme.components.pageHeader.TitleWrapper.titleSize.medium;
  }
}), U = /* @__PURE__ */ o.div.withConfig({
  displayName: "pageHeader__PageHeaderContainer",
  componentId: "bfy3bu-2"
})(["display:", ";flex-direction:", ";row-gap:", ";justify-content:", ";padding:", ";background:", ";@media ", "{padding:", ";}@media ", "{padding:", ";}@media ", "{padding:", ";}"], function(e) {
  return e.theme.components.pageHeader.PageHeaderContainer.display;
}, function(e) {
  return e.theme.components.pageHeader.PageHeaderContainer.flexDirection;
}, function(e) {
  return e.theme.components.pageHeader.PageHeaderContainer.rowGap;
}, function(e) {
  return e.theme.components.pageHeader.PageHeaderContainer.justifyContent;
}, function(e) {
  return e.theme.components.pageHeader.PageHeaderContainer.padding;
}, function(e) {
  var r = e.$hideBackground, t = c(e, A);
  return r ? t.theme.components.pageHeader.PageHeaderContainer.background.hide : t.theme.components.pageHeader.PageHeaderContainer.background.default;
}, p.laptopAndUp, function(e) {
  return e.theme.components.pageHeader.PageHeaderContainer.laptopAndUp.padding;
}, p.desktopAndUp, function(e) {
  return e.theme.components.pageHeader.PageHeaderContainer.desktopAndUp.padding;
}, p.wideScreenAndUp, function(e) {
  return e.theme.components.pageHeader.PageHeaderContainer.wideScreenAndUp.padding;
}), I = /* @__PURE__ */ o.div.withConfig({
  displayName: "pageHeader__TitleContainer",
  componentId: "bfy3bu-3"
})(["display:", ";justify-content:", ";"], function(e) {
  return e.theme.components.pageHeader.TitleContainer.display;
}, function(e) {
  return e.theme.components.pageHeader.TitleContainer.justifyContent;
}), H = /* @__PURE__ */ o.div.withConfig({
  displayName: "pageHeader__ActionButtonWrapper",
  componentId: "bfy3bu-4"
})(["display:", ";gap:", ";flex-direction:", ";button{width:", ";}@media ", "{flex-direction:", ";gap:", ";}"], function(e) {
  return e.theme.components.pageHeader.ActionButtonWrapper.display;
}, function(e) {
  return e.theme.components.pageHeader.ActionButtonWrapper.gap;
}, function(e) {
  return e.theme.components.pageHeader.ActionButtonWrapper.flexDirection;
}, function(e) {
  return e.theme.components.pageHeader.ActionButtonWrapper.button.width;
}, p.tabletAndUp, function(e) {
  return e.theme.components.pageHeader.ActionButtonWrapper.tabletAndUp.flexDirection;
}, function(e) {
  return e.theme.components.pageHeader.ActionButtonWrapper.tabletAndUp.gap;
}), j = /* @__PURE__ */ o(b).withConfig({
  displayName: "pageHeader__SubTitleWrapper",
  componentId: "bfy3bu-5"
})(["align-self:", ";color:", ";font-family:", ";font-size:", ";font-style:", ";font-weight:", ";line-height:", ";"], function(e) {
  return e.theme.components.pageHeader.SubTitleWrapper.alignSelf;
}, function(e) {
  return e.theme.components.pageHeader.SubTitleWrapper.color;
}, function(e) {
  return e.theme.components.pageHeader.SubTitleWrapper.fontFamily;
}, function(e) {
  return e.theme.components.pageHeader.SubTitleWrapper.fontSize;
}, function(e) {
  return e.theme.components.pageHeader.SubTitleWrapper.fontStyle;
}, function(e) {
  return e.theme.components.pageHeader.SubTitleWrapper.fontWeight;
}, function(e) {
  return e.theme.components.pageHeader.SubTitleWrapper.lineHeight;
}), N = /* @__PURE__ */ o.p.withConfig({
  displayName: "pageHeader__DescriptionWrapper",
  componentId: "bfy3bu-6"
})(["", " align-self:", ";color:", ";font-family:", ";font-size:", ";font-style:", ";font-weight:", ";line-height:", ";"], _(), function(e) {
  return e.theme.components.pageHeader.DescriptionWrapper.alignSelf;
}, function(e) {
  return e.theme.components.pageHeader.DescriptionWrapper.color;
}, function(e) {
  return e.theme.components.pageHeader.DescriptionWrapper.fontFamily;
}, function(e) {
  return e.theme.components.pageHeader.DescriptionWrapper.fontSize;
}, function(e) {
  return e.theme.components.pageHeader.DescriptionWrapper.fontStyle;
}, function(e) {
  return e.theme.components.pageHeader.DescriptionWrapper.fontWeight;
}, function(e) {
  return e.theme.components.pageHeader.DescriptionWrapper.lineHeight;
}), L = /* @__PURE__ */ o.div.withConfig({
  displayName: "pageHeader__TitleSubTitleWrapper",
  componentId: "bfy3bu-7"
})(["display:", ";flex-direction:", ";gap:", ";"], function(e) {
  return e.theme.components.pageHeader.TitleSubTitleWrapper.display;
}, function(e) {
  return e.theme.components.pageHeader.TitleSubTitleWrapper.flexDirection;
}, function(e) {
  return e.theme.components.pageHeader.TitleSubTitleWrapper.gap;
});
function qe(e) {
  var r = e.children, t = e.actionButtons, u = e.titleProp, d = u === void 0 ? {
    size: "medium",
    title: "Pageheader title",
    headingLevel: "h1"
  } : u, m = e.subTitleProp, l = e.description, g = e.hideBackground, W = g === void 0 ? !1 : g, s = e.bottomStroke, y = s === void 0 ? !0 : s, f = e.breadCrumbContent, h = e.tabContent, S = c(e, D), C = w({
    label: "PageHeader"
  }), i = !1, T = B(), v = T.width;
  return v < 1024 ? i = !0 : i = !1, /* @__PURE__ */ a(U, Object.assign({
    $hideBackground: W
  }, S, C, {
    children: [f && /* @__PURE__ */ n("div", {
      children: f
    }), /* @__PURE__ */ a(z, {
      children: [/* @__PURE__ */ a(L, {
        children: [/* @__PURE__ */ a(I, {
          children: [/* @__PURE__ */ n($, {
            $titleSize: d.size,
            as: d.headingLevel,
            children: d.title
          }), !i && !!t && /* @__PURE__ */ n(H, {
            children: t
          })]
        }), m && /* @__PURE__ */ n(j, {
          as: m.headingLevel,
          children: m.subTitle
        })]
      }), l && /* @__PURE__ */ n(N, {
        children: l
      }), i && !!t && /* @__PURE__ */ n(H, {
        children: t
      })]
    }), h && /* @__PURE__ */ n("div", {
      children: h
    }), r && /* @__PURE__ */ n("div", {
      children: r
    }), y && /* @__PURE__ */ n(k, {})]
  }));
}
export {
  qe as PageHeader
};
